// extracted by mini-css-extract-plugin
export var deleteIcon = "_qx-5";
export var deleteOption = "_qx-3";
export var divider = "_qx-2";
export var downloadIcon = "_qx-4";
export var drawer = "_qx-0";
export var drawerFooter = "_qx-6";
export var drawerOpen = "_qx-1";
export var highlighted = "_qx-7";
export var lighterHighlight = "_qx-8";